import React, { Component } from "react";
import {
    Container,
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Tooltip,
    Link as MuiLink,
    Button,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Snackbar,
    Alert,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import EventIcon from '@mui/icons-material/Event';
import PeopleIcon from '@mui/icons-material/People';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PresentationIcon from '@mui/icons-material/Slideshow';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { getEventById, getPresentationsByEvent, createPastEventPresentation } from "./apiEvents";
import { listGroups } from "../group/apigroup";
import { isAuthenticated } from "../auth";
import Moment from 'moment';
import { getSchedule } from './apiEvents';
import Footer from '../core/Footer';

const ADD_PRESENTATION_USER_ID = '5e2611483f99fa3bb4dd922a';

const emptyPresentationForm = {
    title: '',
    description: '',
    datePresented: '',
    year: '',
    committee: '',
    committeeName: '',
    videoUrl: '',
};

class ShowCaseEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userId: '',
            event: null,
            schedule: [],
            presentations: [],
            eventId: this.props.match.params.eventId,
            groups: [],
            addPresentationOpen: false,
            presentationForm: { ...emptyPresentationForm },
            presentationFile: null,
            savingPresentation: false,
            presentationError: '',
            presentationSuccess: false,
        };
    }

    componentWillMount() {
        this.setState({ eventId: this.props.match.params.eventId })

        // this.setState({ userId: isAuthenticated().userId})

        getEventById(this.state.eventId, isAuthenticated() && isAuthenticated().token).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {

                this.setState({ event: data[0] });
            }
        });

        this.loadPresentations();

        getSchedule('Spring 2021', isAuthenticated() && isAuthenticated().token).then(scheduleData => {
            if (scheduleData.error) {
                console.log(scheduleData.error);
            } else {
                this.setState({ schedule: scheduleData });
            }
        });

        // Only the locked operator user needs the committee list (for the Add Presentation dialog).
        const auth = isAuthenticated();
        if (auth && auth.userId === ADD_PRESENTATION_USER_ID) {
            listGroups().then(data => {
                if (Array.isArray(data)) {
                    this.setState({ groups: data });
                }
            });
        }
    }

    loadPresentations = () => {
        getPresentationsByEvent(this.state.eventId, "title", "asc", isAuthenticated() && isAuthenticated().token).then(presentations => {
            if (presentations.error) {
                console.log(presentations.error);
            } else {
                this.setState({ presentations: presentations });
            }
        });
    };

    openPresentationDialog = () => {
        const auth = isAuthenticated();
        const event = this.state.event;
        const startYear = event && event.startDate
            ? (String(event.startDate).match(/\b(19|20)\d{2}\b/) || [])[0] || ''
            : '';
        this.setState({
            addPresentationOpen: true,
            presentationForm: { ...emptyPresentationForm, year: startYear },
            presentationFile: null,
            presentationError: '',
        });
    };

    closePresentationDialog = () => {
        if (this.state.savingPresentation) return;
        this.setState({ addPresentationOpen: false });
    };

    handlePresentationFormChange = (field) => (e) => {
        const value = e.target.value;
        this.setState(prev => {
            const next = { ...prev.presentationForm, [field]: value };
            if (field === 'committee') {
                const group = (prev.groups || []).find(g => g._id === value);
                next.committeeName = group ? group.name : '';
            }
            return { presentationForm: next };
        });
    };

    handlePresentationFileChange = (e) => {
        const file = e.target.files && e.target.files[0];
        this.setState({ presentationFile: file || null });
    };

    submitPresentation = () => {
        const { presentationForm, presentationFile, eventId } = this.state;
        if (!presentationForm.title.trim()) {
            this.setState({ presentationError: 'Title is required.' });
            return;
        }

        const formData = new FormData();
        formData.append('title', presentationForm.title.trim());
        formData.append('description', presentationForm.description.trim());
        formData.append('datePresented', presentationForm.datePresented.trim());
        formData.append('year', presentationForm.year.trim());
        formData.append('committeeName', presentationForm.committeeName.trim());
        formData.append('eventId', eventId);
        if (presentationForm.committee) formData.append('committee', presentationForm.committee);
        if (presentationFile) {
            formData.append('video', presentationFile);
        } else if (presentationForm.videoUrl.trim()) {
            formData.append('video', presentationForm.videoUrl.trim());
        }

        this.setState({ savingPresentation: true, presentationError: '' });
        createPastEventPresentation(formData).then(resp => {
            this.setState({ savingPresentation: false });
            if (!resp || resp.error) {
                this.setState({ presentationError: (resp && resp.error) || 'Could not create presentation.' });
                return;
            }
            this.setState({
                addPresentationOpen: false,
                presentationForm: { ...emptyPresentationForm },
                presentationFile: null,
                presentationSuccess: true,
            });
            this.loadPresentations();
        });
    };

    getCaret(direction) {
        if (direction === 'asc') {
            return (
                <span> [up]</span>
            );
        }
        if (direction === 'desc') {
            return (
                <span> [down]</span>
            );
        }
        return (
            <span> [up/down]</span>
        );
    }


    formatLinkField(presId) {
        return (
            <Button
                href={`/presentation/${presId}`}
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                size="small"
                endIcon={<OpenInNewIcon />}
                sx={{
                    backgroundColor: '#FF6600',
                    '&:hover': {
                        backgroundColor: '#e55a00',
                    }
                }}
            >
                View
            </Button>
        )
    }

    sortPresentations(eventId, sortField, sortDirection) {

        getPresentationsByEvent(eventId, sortField, sortDirection, isAuthenticated() && isAuthenticated().token).then(presentations => {
            if (presentations.error) {
                console.log(presentations.error);
            } else {
                this.setState({ presentations: presentations });
            }
        });
    };

    render() {
        const { event, presentations, groups, addPresentationOpen, presentationForm,
            presentationFile, savingPresentation, presentationError, presentationSuccess } = this.state;

        if (!event) {
            return <></>;
        }

        const auth = isAuthenticated();
        const canAddPresentation = !!auth && auth.userId === ADD_PRESENTATION_USER_ID;

        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 5, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <EventIcon sx={{ fontSize: 56 }} />
                            <Box>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    {event.title}
                                </Typography>
                                <Typography variant="h6" sx={{ opacity: 0.9 }}>
                                    Event Presentations & Details
                                </Typography>
                            </Box>
                        </Box>

                        {/* Event Stats */}
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 3 }}>
                            <Chip
                                icon={<EventIcon sx={{ color: 'white !important' }} />}
                                label={event.type}
                                sx={{
                                    backgroundColor: '#FF6600',
                                    color: 'white',
                                    fontSize: '1rem',
                                    py: 2.5,
                                    px: 1,
                                    '& .MuiChip-icon': {
                                        color: 'white'
                                    }
                                }}
                            />
                            <Chip
                                icon={<PeopleIcon sx={{ color: 'white !important' }} />}
                                label={`${event.attendance} Attendees`}
                                sx={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    fontSize: '1rem',
                                    py: 2.5,
                                    px: 1,
                                    '& .MuiChip-icon': {
                                        color: 'white'
                                    }
                                }}
                            />
                            <Chip
                                icon={<CalendarMonthIcon sx={{ color: 'white !important' }} />}
                                label={Moment(event.startDate).format('MMMM Do YYYY')}
                                sx={{
                                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    fontSize: '1rem',
                                    py: 2.5,
                                    px: 1,
                                    '& .MuiChip-icon': {
                                        color: 'white'
                                    }
                                }}
                            />
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="lg">

                {canAddPresentation && (
                    <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            onClick={this.openPresentationDialog}
                            variant="contained"
                            startIcon={<AddIcon />}
                            sx={{
                                backgroundColor: '#FF6600',
                                color: 'white',
                                fontWeight: 600,
                                '&:hover': { backgroundColor: '#cc5200' },
                            }}
                        >
                            Add Presentation
                        </Button>
                    </Box>
                )}

                {/* No Content State */}
                {(presentations.length === 0) && (
                    <Paper
                        elevation={2}
                        sx={{
                            p: 5,
                            mt: 4,
                            mb: 6,
                            textAlign: 'center',
                            borderRadius: 3,
                            backgroundColor: 'rgba(0, 62, 126, 0.02)'
                        }}
                    >
                        <PresentationIcon sx={{ fontSize: 80, color: '#003E7E', opacity: 0.3, mb: 2 }} />
                        <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E', mb: 2 }}>
                            Content Not Yet Available
                        </Typography>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Presentations for this event will be posted here soon.
                        </Typography>
                        <Button
                            href="/grouplist"
                            variant="contained"
                            sx={{
                                backgroundColor: '#003E7E',
                                '&:hover': {
                                    backgroundColor: '#002a5a',
                                }
                            }}
                        >
                            Back to Committees
                        </Button>
                    </Paper>
                )}
                {/* Presentations Table */}
                {(presentations.length > 0) && (
                    <Box sx={{ mt: 4, mb: 6 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
                            <PresentationIcon sx={{ fontSize: 40, color: '#003E7E' }} />
                            <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                Event Presentations
                            </Typography>
                        </Box>
                        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
                            Click on the column headers to sort presentations by title, description, committee, or date.
                        </Typography>
                        <TableContainer component={Paper} sx={{ borderRadius: 3, overflow: 'hidden' }} elevation={3}>
                            <Table>
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#003E7E' }}>
                                        {/* Title Column */}
                                        <TableCell sx={{ color: 'white', borderBottom: '2px solid #FF6600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>Title</Typography>
                                                <Box>
                                                    <Tooltip title="Sort ascending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "title", "desc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowUpwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Sort descending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "title", "asc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowDownwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        </TableCell>

                                        {/* Description Column */}
                                        <TableCell sx={{ color: 'white', borderBottom: '2px solid #FF6600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>Description</Typography>
                                                <Box>
                                                    <Tooltip title="Sort ascending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "description", "desc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowUpwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Sort descending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "description", "asc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowDownwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        </TableCell>

                                        {/* Committee Column */}
                                        <TableCell sx={{ color: 'white', borderBottom: '2px solid #FF6600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>Committee</Typography>
                                                <Box>
                                                    <Tooltip title="Sort ascending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "committeeName", "desc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowUpwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Sort descending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "committeeName", "asc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowDownwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        </TableCell>

                                        {/* Date Column */}
                                        <TableCell sx={{ color: 'white', borderBottom: '2px solid #FF6600' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>Date</Typography>
                                                <Box>
                                                    <Tooltip title="Sort ascending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "datePresented", "desc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowUpwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    <Tooltip title="Sort descending">
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => this.sortPresentations(event._id, "datePresented", "asc")}
                                                            sx={{ color: 'white' }}
                                                        >
                                                            <ArrowDownwardIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Box>
                                            </Box>
                                        </TableCell>

                                        {/* Link Column */}
                                        <TableCell sx={{ color: 'white', borderBottom: '2px solid #FF6600' }}>
                                            <Typography variant="h6" sx={{ color: 'white', fontWeight: 600 }}>Link</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {presentations.map((presentation, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0, 62, 126, 0.04)',
                                                },
                                                '&:nth-of-type(even)': {
                                                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                                                }
                                            }}
                                        >
                                            <TableCell sx={{ fontWeight: 500 }}>{presentation.title}</TableCell>
                                            <TableCell>{presentation.description}</TableCell>
                                            <TableCell>{presentation.committeeName}</TableCell>
                                            <TableCell>{presentation.datePresented}</TableCell>
                                            <TableCell>{this.formatLinkField(presentation._id)}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </Container>

            {/* Add Presentation dialog (visible only to ADD_PRESENTATION_USER_ID) */}
            <Dialog open={addPresentationOpen} onClose={this.closePresentationDialog} maxWidth="sm" fullWidth>
                <DialogTitle sx={{ color: '#003E7E', fontWeight: 600 }}>Add Presentation</DialogTitle>
                <DialogContent dividers>
                    {presentationError && (
                        <Alert severity="error" sx={{ mb: 2 }}>{presentationError}</Alert>
                    )}
                    <TextField
                        label="Title"
                        fullWidth
                        required
                        margin="dense"
                        value={presentationForm.title}
                        onChange={this.handlePresentationFormChange('title')}
                    />
                    <TextField
                        label="Description"
                        fullWidth
                        margin="dense"
                        multiline
                        minRows={2}
                        value={presentationForm.description}
                        onChange={this.handlePresentationFormChange('description')}
                    />
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            label="Date Presented"
                            margin="dense"
                            placeholder="e.g. October 4, 2025"
                            value={presentationForm.datePresented}
                            onChange={this.handlePresentationFormChange('datePresented')}
                            sx={{ flex: 1 }}
                        />
                        <TextField
                            label="Year"
                            margin="dense"
                            placeholder="e.g. 2025"
                            value={presentationForm.year}
                            onChange={this.handlePresentationFormChange('year')}
                            sx={{ width: 140 }}
                        />
                    </Box>
                    <FormControl fullWidth margin="dense">
                        <InputLabel id="committee-label">Committee</InputLabel>
                        <Select
                            labelId="committee-label"
                            label="Committee"
                            value={presentationForm.committee}
                            onChange={this.handlePresentationFormChange('committee')}
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            {groups.map(g => (
                                <MenuItem key={g._id} value={g._id}>{g.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Box sx={{ mt: 2, p: 2, border: '1px dashed #ccc', borderRadius: 2 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                            Video (upload a file or paste a URL)
                        </Typography>
                        <Button
                            component="label"
                            variant="outlined"
                            startIcon={<UploadFileIcon />}
                            sx={{ mb: 1, mr: 2 }}
                        >
                            {presentationFile ? 'Change file' : 'Choose video file'}
                            <input
                                type="file"
                                hidden
                                accept="video/*"
                                onChange={this.handlePresentationFileChange}
                            />
                        </Button>
                        {presentationFile && (
                            <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary' }}>
                                {presentationFile.name} ({Math.round(presentationFile.size / (1024 * 1024))} MB)
                            </Typography>
                        )}
                        <TextField
                            label="…or video URL"
                            fullWidth
                            margin="dense"
                            placeholder="https://…"
                            value={presentationForm.videoUrl}
                            onChange={this.handlePresentationFormChange('videoUrl')}
                            disabled={!!presentationFile}
                            helperText={presentationFile ? 'URL ignored when a file is selected' : 'Used only if no file is uploaded'}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closePresentationDialog} disabled={savingPresentation}>Cancel</Button>
                    <Button
                        onClick={this.submitPresentation}
                        variant="contained"
                        disabled={savingPresentation}
                        startIcon={savingPresentation ? <CircularProgress size={16} color="inherit" /> : null}
                        sx={{ backgroundColor: '#003E7E', '&:hover': { backgroundColor: '#002a57' } }}
                    >
                        {savingPresentation ? 'Uploading...' : 'Create Presentation'}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={presentationSuccess}
                autoHideDuration={5000}
                onClose={() => this.setState({ presentationSuccess: false })}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    onClose={() => this.setState({ presentationSuccess: false })}
                    severity="success"
                    sx={{ width: '100%' }}
                >
                    Presentation added successfully.
                </Alert>
            </Snackbar>

            <Footer />
            </>
        );
    }
}

export default ShowCaseEvent;
